import(/* webpackMode: "eager" */ "/opt/build/repo/hotel-website/src/app/not-found.tsx");
